<div #toastWrapper class="text-theme-dark-gray h-fit w-105 rounded-md text-sm shadow-md">
  @switch (toastConfig().type) {
    @case ('success') {
      <shared-core-success-toast
        [message]="toastConfig().message"
        (closeToast)="closeToast.emit(toastConfig())" />
    }
    @case ('error') {
      <shared-core-error-toast
        [message]="toastConfig().message"
        (closeToast)="closeToast.emit(toastConfig())" />
    }
    @case ('warning') {
      <shared-core-warning-toast
        [message]="toastConfig().message"
        (closeToast)="closeToast.emit(toastConfig())" />
    }
    @case ('observable') {
      <shared-core-observable-toast [message]="toastConfig().message" />
    }
  }
</div>
